/* istanbul ignore file */

import { Module } from 'vuex';
import { AppState } from '..';

import { BuilderMode, SelectableMenuItem, SelectableVariantMenuItem } from '@/models';
import { prefixValues } from '@/helpers/util';

const MUTATION_NAMES = {
  SET_BUILDER_MODE: 'setBuilderMode',
  SET_SELECTED_VARIANT: 'setSelectedVariant',
  SET_SELECTED_ITEMS: 'setSelectedItems',
  SET_DISPLAYED_VARIANTS: 'setDisplayedVariants',
  SET_OPTED_OUT_DEFAULT_CONTENT_ITEMS: 'setOptedOutDefaultContentItems',
  SET_OPTED_OUT_ITEM_SECTIONS: 'setOptedOutItemSections',
  SET_CUSTOMIZING_ITEM: 'setCustomizingItem',
  SET_MISSING_ITEM_SECTIONS: 'setMissingItemSections'
};

export const MUTATIONS = prefixValues(MUTATION_NAMES, 'mealBuilder/');

export interface MealBuilderModuleState {
  builderMode: BuilderMode | null;
  selectedVariant: SelectableVariantMenuItem | null;
  selectedItems: SelectableMenuItem[];
  displayedVariants: SelectableVariantMenuItem[];
  optedOutDefaultContentItemIds: string[];
  optedOutItemSectionIds: string[];
  customizingItem: SelectableMenuItem | null;
  missingItemSections: string[];
}

export function makeMealBuilderModule(): Module<MealBuilderModuleState, AppState> {
  return {
    namespaced: true,
    state: {
      builderMode: null,
      selectedVariant: null,
      selectedItems: [],
      displayedVariants: [],
      optedOutDefaultContentItemIds: [],
      optedOutItemSectionIds: [],
      customizingItem: null,
      missingItemSections: []
    },
    mutations: {
      [MUTATION_NAMES.SET_BUILDER_MODE](state, mode: BuilderMode) {
        state.builderMode = mode;
      },
      [MUTATION_NAMES.SET_SELECTED_VARIANT](state, variant: SelectableVariantMenuItem) {
        state.selectedVariant = variant;
      },
      [MUTATION_NAMES.SET_SELECTED_ITEMS](state, items: SelectableMenuItem[]) {
        state.selectedItems = items;
      },
      [MUTATION_NAMES.SET_DISPLAYED_VARIANTS](state, variants: SelectableVariantMenuItem[]) {
        state.displayedVariants = variants;
      },
      [MUTATION_NAMES.SET_OPTED_OUT_DEFAULT_CONTENT_ITEMS](state, itemIds) {
        state.optedOutDefaultContentItemIds = itemIds.slice();
      },
      [MUTATION_NAMES.SET_OPTED_OUT_ITEM_SECTIONS](state, ids) {
        state.optedOutItemSectionIds = ids.slice();
      },
      [MUTATION_NAMES.SET_CUSTOMIZING_ITEM](state, item: SelectableMenuItem) {
        state.customizingItem = item;
      },
      [MUTATION_NAMES.SET_MISSING_ITEM_SECTIONS](state, sections: string[]) {
        state.missingItemSections = sections;
      }
    },
  };
}
